import { render, staticRenderFns } from "./metric-object-reference.vue?vue&type=template&id=b1c20ef0&"
import script from "./metric-object-reference.vue?vue&type=script&lang=js&"
export * from "./metric-object-reference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports